import React, { useState } from 'react';
import { ListColumn } from '../Datalist/Datalist';
import Datalist from '../Datalist/Datalist';
import { format } from 'date-fns';
import { Modal } from 'react-bootstrap'; // Import modal components
import { API } from '../../data/API/API';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for routing
import './FollowUpReviewTable.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { statusIconColorMap } from '../../lib/utils'; // Import statusIconColorMap from utils.ts
import { faExclamationCircle, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import InternalCommentsModal from "../InternalComments/InternalCommentsModal";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
interface Review {
    id: number;
    supplierName: string;
    orgNumber: string;
    createdDate: string;
    createdBy: string;
    period: string;
    endPeriod?: string; // Optional in case it's missing
    hasInternalComment?: boolean; // NY
    handledComment?:string|null;
}

interface FollowUpReviewTableProps {
    searchText: string;
    orgNumber: string;
    name: string;
    isLoading: boolean;
    reviewData: Review[];
     refetchData: () => void;
}

const FollowUpReviewTable: React.FC<FollowUpReviewTableProps> = ({
    searchText,
    orgNumber,
    name,
    isLoading,
    reviewData,
    refetchData
}) => {
    const [showModal, setShowModal] = useState(false); // Modal visibility state
    const [modalData, setModalData] = useState<any[]>([]); // Store sendings data
    const [loadingModal, setLoadingModal] = useState(false); // Loading state for modal
    const [selectedReviewId, setSelectedReviewId] = useState<number | null>(null); // Store the selected reviewId
    const [showCommentsModal, setShowCommentsModal] = useState(false);
const [commentsTargetReviewId, setCommentsTargetReviewId] = useState<number | null>(null);
const [showSendingCommentsModal, setShowSendingCommentsModal] = useState(false);
const [commentsTargetSendingId, setCommentsTargetSendingId] = useState<number | null>(null);
const [showConfirmReviewHandled, setShowConfirmReviewHandled] = useState(false);
const [reviewHandledLoading, setReviewHandledLoading] = useState(false);
const [handledComment, setHandledComment] = useState("");
const [handledCommentError, setHandledCommentError] = useState<string | null>(null);
const [selectedReviewHandledComment, setSelectedReviewHandledComment] = useState<string | null>(null);



const openSendingComments = (sendingId: number) => {
  setCommentsTargetSendingId(sendingId);
  setShowSendingCommentsModal(true);
};

    const navigate = useNavigate(); // Initialize the navigation hook


const openReviewComments = (reviewId: number) => {
  setCommentsTargetReviewId(reviewId);
  setShowCommentsModal(true);
};

    // Function to handle row click
  //   const handleRowClick = async (review:Review) => {
  //      setHandledComment("");
  // setHandledCommentError(null);
  //       setLoadingModal(true);
  //       setSelectedReviewId(reviewId); // Set the selected reviewId
  //       try {
  //           const sendings = await API.Sendings.GetSendingsByReviewId(reviewId); // Fetch sendings by reviewId
  //           setModalData(sendings); // Set the sendings data
  //           setShowModal(true); // Show the modal
  //       } catch (error) {
  //           console.error("Fel vid hämtning av sändningar:", error);
  //       } finally {
  //           setLoadingModal(false);
  //       }
  //   };
  const handleRowClick = async (review: Review) => {
  // reset för "slutför"-flödet
  setHandledComment("");
  setHandledCommentError(null);

  setLoadingModal(true);
  setSelectedReviewId(review.id);
  setSelectedReviewHandledComment(review.handledComment ?? null);

  try {
    const sendings = await API.Sendings.GetSendingsByReviewId(review.id);
    setModalData(sendings);
    setShowModal(true);
  } catch (error) {
    console.error("Fel vid hämtning av sändningar:", error);
  } finally {
    setLoadingModal(false);
  }
};

    // Close modal
    const handleCloseModal = () => { 
  setShowModal(false);
  setHandledComment("");
  setHandledCommentError(null);
  setSelectedReviewHandledComment(null);
  setModalData([]);
  setSelectedReviewId(null);
};


    // Filter review data based on search text, orgNumber, and name
    const filteredData = reviewData.filter(review => {
        const matchesSearch = review.supplierName.toLowerCase().includes(searchText.toLowerCase()) ||
            review.orgNumber.includes(searchText) ||
            review.createdBy.toLowerCase().includes(searchText) ||
            review.id.toString().includes(searchText);

        const matchesOrgNumber = !orgNumber || review.orgNumber.includes(orgNumber);
        const matchesName = !name || review.supplierName.toLowerCase().includes(name.toLowerCase());

        return matchesSearch && matchesOrgNumber && matchesName;
    });

    // Define columns for the review table
    const columns: ListColumn<Review>[] = [
        {
            key: 'id',
            fieldName: 'id',
            name: 'Id',
            maxWidth: '10%',
            minWidth: 50,
            isActive: true,
            sorting: true,
            onRender: (item: Review) => item.id.toString(),
            footer: (items: Review[]) => `Totalt antal rader: ${items.length}`,
        },
        {
  key: "internalComments",
  fieldName: "internalComments",
  name: "",
  maxWidth: 60,
  minWidth: 60,
  isActive: true,
  sorting: false,
  onRender: (item: Review) => (
    <span
      onClick={(ev) => {
        ev.stopPropagation();
        openReviewComments(item.id);
      }}
      style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
      title="Interna kommentarer"
    >
      <FontAwesomeIcon
        icon={faCommentDots}
        style={{ color: item.hasInternalComment ? "#0d6efd" : "#adb5bd" }}
      />
    </span>
  ),
},

        {
            key: 'supplierName',
            fieldName: 'supplierName',
            name: 'Organisation',
            maxWidth: '40%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: Review) => `${item.supplierName} - ${item.orgNumber}`,
        },
        {
            key: 'createdDate',
            fieldName: 'createdDate',
            name: 'Datum',
            maxWidth: '20%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: Review) => {
                const parsedDate = new Date(item.createdDate);
                return isNaN(parsedDate.getTime()) ? 'Ogiltigt datum' : format(parsedDate, 'yyyy-MM-dd');
            },
        },
        {
            key: 'createdBy',
            fieldName: 'createdBy',
            name: 'Skapad av',
            maxWidth: '15%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: Review) => item.createdBy,
        },
        {
            key: 'period',
            fieldName: 'period',
            name: 'Start Period',
            maxWidth: '15%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: Review) => item.period,
        },
        {
            key: 'endPeriod',
            fieldName: 'endPeriod',
            name: 'Slut Period',
            maxWidth: '15%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: Review) => item.endPeriod || 'N/A', // Display 'N/A' if endPeriod is missing
        },
    ];

    // Define columns for the modal (Sendings table)
    const modalColumns: ListColumn<any>[] = [
        {
            key: 'id',
            fieldName: 'id',
            name: 'Id',
            maxWidth: '10%',
            minWidth: 50,
            isActive: true,
            sorting: true
        },
        {
  key: "internalComments",
  fieldName: "internalComments",
  name: "",
  maxWidth: 60,
  minWidth: 60,
  isActive: true,
  sorting: false,
  onRender: (item: any) => (
    <span
      onClick={(ev) => {
        ev.stopPropagation();
        openSendingComments(item.id);
      }}
      style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
      title="Interna kommentarer"
    >
      <FontAwesomeIcon
        icon={faCommentDots}
        style={{ color: item.hasInternalComment ? "#0d6efd" : "#adb5bd" }}
      />
    </span>
  ),
},

        {
            key: 'customerName',
            fieldName: 'customerName',
            name: 'Medlem',
            maxWidth: '40%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: any) => (
                <div
                    onClick={() => navigate(`/followup-sending/${item.id}`)}  // Navigate to FollowUpSending page
                    className="clickable-text" // Add class for styling
                >
                    {`${item.customerName} - ${item.orgNumber}`}
                </div>
            )
        },
        {
            key: 'createdDate',
            fieldName: 'createdDate',
            name: 'Datum',
            maxWidth: '20%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: any) => {
                const parsedDate = new Date(item.createdDate);
                return isNaN(parsedDate.getTime()) ? 'Ogiltigt datum' : format(parsedDate, 'yyyy-MM-dd');  // Format to YYYY-MM-DD
            }
        },
        {
            key: 'updatedDate',
            fieldName: 'updatedDate',
            name: 'Uppdaterad',
            maxWidth: '20%',
            minWidth: 100,
            isActive: true,
            sorting: true,
            onRender: (item: any) => {
                const parsedDate = new Date(item.updatedDate);
                return isNaN(parsedDate.getTime()) ? 'Ogiltigt datum' : format(parsedDate, 'yyyy-MM-dd');  // Format to YYYY-MM-DD
            }
        },
        {
            key: 'status',
            fieldName: 'status',
            name: 'Status',
            maxWidth: '20%',
            minWidth: 50,
            isActive: true,
            sorting: true,
            onRender: (item: any) => {
                const statusInfo = statusIconColorMap[item.status] || { label: 'Unknown', color: '#000', icon: faExclamationCircle };
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FontAwesomeIcon icon={statusInfo.icon} style={{ marginRight: 8, color: statusInfo.color }} />
                        <span>{statusInfo.label}</span>
                    </div>
                );
            }
        },
        {
            key: 'isHandled',
            fieldName: 'isHandled',
            name: 'Slutförd',
            maxWidth: '15%',
            minWidth: 50,
            isActive: true,
            sorting: true,
            onRender: (item: any) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FontAwesomeIcon
                        icon={item.isHandled ? faCheckCircle : faTimesCircle}
                        style={{ marginRight: 8, color: item.isHandled ? '#07A235' : '#DC143C' }}
                    />
                    <span>{item.isHandled ? 'Ja' : 'Nej'}</span>
                </div>
            )
        }
    ];
const allHandled = modalData.length > 0 && modalData.every(x => x.isHandled);

    return (
        <div className="follow-up-review-table-wrapper">
            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <Datalist
                    items={filteredData}
                    isLoading={isLoading}
                    columns={columns}
                    onClick={(item: Review) => handleRowClick(item)} // Pass reviewId on row click
                    setColumns={() => { }}
                    initialSortKey="createdDate"
                    descendingSort={false}
                    noItemsText="Inga granskningar att visa"
                    uniqueKey="id"
                />
            </div>

            {/* Modal for displaying sendings */}
            <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Utskick för granskning {selectedReviewId}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {allHandled && selectedReviewHandledComment?.trim() && (
  <div style={{ marginBottom: 12, padding: 12, border: "1px solid #dee2e6", borderRadius: 6 }}>
    <div style={{ fontWeight: 600, marginBottom: 6 }}>Slutkommentar</div>
    <div style={{ whiteSpace: "pre-wrap" }}>{selectedReviewHandledComment}</div>

    <div style={{ marginTop: 10, fontSize: 13, color: "#6c757d" }}>
      Slutkommentaren låses när granskningen markeras som slutförd. Behöver du ändra den?
      Markera granskningen som <b>ej slutförd</b> och slutför igen med en ny kommentar.
    </div>
  </div>
)}
        
                    {loadingModal ? (
                        <p>Laddar...</p>
                    ) : (
                        <Datalist
                            items={modalData}
                            isLoading={loadingModal}
                            columns={modalColumns}
                            setColumns={() => { }}
                            initialSortKey="createdDate"
                            descendingSort={false}
                            noItemsText="Inga utskick att visa"
                            uniqueKey="id"
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
  <button
    className={`btn handled-button ${allHandled ? 'unhandled' : 'handled'}`}
    onClick={() => setShowConfirmReviewHandled(true)}
    disabled={loadingModal || modalData.length === 0}
  >
    {allHandled ? 'Markera granskning som ej slutförd' : 'Markera granskning som slutförd'}
  </button>

  <button className='btn button-cancel' onClick={handleCloseModal}>
    Stäng
  </button>
</Modal.Footer>

            </Modal>
            <Modal
  show={showConfirmReviewHandled}
  centered
  onHide={() => setShowConfirmReviewHandled(false)}
>
  <Modal.Header closeButton>
    <Modal.Title>Bekräfta Åtgärd</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Är du säker på att du vill{" "}
    {allHandled ? "markera hela granskningen som ej slutförd" : "markera hela granskningen som slutförd"}
    ?
    {!allHandled && (
    <div style={{ marginTop: 12 }}>
      <label style={{ fontWeight: 600 }}>Kommentar (obligatorisk)</label>
      <textarea
        className="form-control"
        rows={3}
        value={handledComment}
        onChange={(e) => {
          setHandledComment(e.target.value);
          if (handledCommentError) setHandledCommentError(null);
        }}
        placeholder="Skriv varför granskningen slutförs..."
        disabled={reviewHandledLoading}
      />
      {handledCommentError && (
        <div style={{ color: "#DC143C", marginTop: 6 }}>{handledCommentError}</div>
      )}
    </div>
  )}
  </Modal.Body>
  <Modal.Footer>
    <button className="btn button-cancel" onClick={() => setShowConfirmReviewHandled(false)}>
      Avbryt
    </button>
    <button
      className="btn"
      // onClick={async () => {
      //   if (!selectedReviewId) return;

      //   const newStatus = !allHandled; 
      //   setReviewHandledLoading(true);
      //   try {
      //     await API.Sendings.UpdateReviewHandledStatus(selectedReviewId, newStatus);
      //     setModalData(prev => prev.map(x => ({ ...x, isHandled: newStatus })));
      //     await refetchData();
      //   } catch (e) {
      //     console.error(e);
      //     alert("Kunde inte uppdatera granskningen.");
      //   } finally {
      //     setReviewHandledLoading(false);
      //     setShowConfirmReviewHandled(false);
      //   }
      // }}
      onClick={async () => {
  if (!selectedReviewId) return;

  const newStatus = !allHandled;

  if (newStatus) {
    const trimmed = handledComment.trim();
    if (!trimmed) {
      setHandledCommentError("Du måste skriva en kommentar för att slutföra granskningen.");
      return;
    }
  }

  setReviewHandledLoading(true);
  try {
    await API.Sendings.UpdateReviewHandledStatus(
      selectedReviewId,
      newStatus,
      newStatus ? handledComment.trim() : undefined
    );
    if (newStatus) {
  setSelectedReviewHandledComment(handledComment.trim());
} else {
  // valfritt: om du bara vill visa slutkommentar när allHandled=true
  setSelectedReviewHandledComment(null);
}
    setModalData(prev => prev.map(x => ({ ...x, isHandled: newStatus })));
    await refetchData();
  } catch (e) {
    console.error(e);
    alert("Kunde inte uppdatera granskningen.");
  } finally {
    setReviewHandledLoading(false);
    setShowConfirmReviewHandled(false);
  }
}}
    disabled={reviewHandledLoading || (!allHandled && !handledComment.trim())}
    >
      {reviewHandledLoading ? "Uppdaterar..." : "Bekräfta"}
    </button>
  </Modal.Footer>
</Modal>

                    {commentsTargetReviewId !== null && (
  <InternalCommentsModal
    show={showCommentsModal}
    onClose={() => setShowCommentsModal(false)}
    targetType="review"
    targetId={commentsTargetReviewId}
    onCreated={() => {
    
    }}
  />
)}

{commentsTargetSendingId !== null && (
  <InternalCommentsModal
    show={showSendingCommentsModal}
    onClose={() => setShowSendingCommentsModal(false)}
    targetType="sending"
    targetId={commentsTargetSendingId}
  />
)}

        </div>
    );
};

export default FollowUpReviewTable;
